import AbstractWebRtcListenerAction from "./AbstractWebRtcListenerAction";
import AbstractWebRtcCall from "~/ts/library/webRtc/AbstractWebRtcCall";

export default class WebRtcCallRequestAnswer extends AbstractWebRtcListenerAction {
    getAction(): string {
        return "webRtcCallRequestAnswer";
    }

    onAction(payload: CometOperatorApplication.WebRtcCallRequestAnswerCometMessageOpenApiModel): void {
        let currentCall = AbstractWebRtcCall.getCurrentCall();
        if (currentCall?.getId() == payload.call.id) {
            currentCall.addLog(`Receive webRtcCallRequestAnswer`, payload);
            currentCall.setCallData(payload.call);
            currentCall.sendAnswer(payload.pairId, payload.offer!);
        }
    }

}